module.exports = {
    type: 'Open question',
    instruction: 'Type the statement of the question below. The student must type the answer in text format.',
    typeHere: 'Type here...',
}